import React, { FC, Fragment, useMemo, useState } from "react"
import { Points as RewardWallet } from "@jnext/ts-axios-contestformat"
import { CMSStaticSection } from "../../../models"
import { JCMSStaticModal } from "../../../JCMSStaticSections/components/JCMSStaticModal"
import { JCMSCard, JCMSCardProps } from "../../JCMSCard"


export interface JCardRewardWalletProps extends RewardWallet {
    cardProps?: JCMSCardProps
}

function getModalProps(rewardWallet: RewardWallet) {
    const title = `${rewardWallet.amount} ${rewardWallet.walletCms?.title}`
    const modalProps: CMSStaticSection.Modal = {
        enabled: true,
        title,
        text: rewardWallet.walletCms?.text,
        type: CMSStaticSection.Types.STATIC_MODAL,
    }
    if (rewardWallet.walletCms?.imageRef) {
        modalProps.image = [
            { src: rewardWallet.walletCms?.imageRef }
        ]
    }
    return modalProps
}
export const JCardRewardWallet: FC<JCardRewardWalletProps> = ({ cardProps, ...rewardWallet }) => {

    const [showModal, setShowModal] = useState<boolean>(false);

    const props = useMemo(() => (
        rewardWalletToSectionCard(rewardWallet)
    ), [rewardWallet])

    const modalProps = useMemo(() => getModalProps(rewardWallet), [rewardWallet])
    return (
        <Fragment>
            <JCMSCard {...props} onClick={() => setShowModal(true)} />
            {
                showModal && (
                    <JCMSStaticModal {...modalProps} open={showModal} onCancel={() => setShowModal(false)} />
                )
            }
        </Fragment>
    )
}



export function rewardWalletToSectionCard(rewardWallet: RewardWallet) {
    const title = `${rewardWallet.amount} ${rewardWallet.walletCms?.title}`
    const props: JCMSCardProps = {
        enabled: true,
        type: CMSStaticSection.Types.STATIC_CARD,
        title,
        text: rewardWallet.walletCms?.text, 
        options: {
            imagePadding: 'medium',
            imagePosition: 'scale-down'
        }
    }
    if (rewardWallet.walletCms?.imageRef) {
        props.image = [
            { src: rewardWallet.walletCms?.imageRef }
        ]
    }
    return props
}

